import api from '../Api';

// RBAC API endpoints for Super Admin
export const rbacApi = {
  // Permissions
  permissions: {
    list: (page = 1, limit = 10, search = '') => 
      api.get(`rbac-service/permissions?page=${page}&limit=${limit}&search=${search}`),
    create: (data) => 
      api.post('rbac-service/permissions', data),
    update: (permissionId, data) => 
      api.put(`rbac-service/permissions/${permissionId}`, data),
    delete: (permissionId) => 
      api.delete(`rbac-service/permissions/${permissionId}`)
  },
  
  // Roles
  roles: {
    list: (page = 1, limit = 10, search = '') => 
      api.get(`rbac-service/roles?page=${page}&limit=${limit}&search=${search}`),
    create: (data) => 
      api.post('rbac-service/roles', data),
    update: (roleId, data) => 
      api.put(`rbac-service/roles/${roleId}`, data)
  },
  
  // Role-Permissions
  rolePermissions: {
    assign: (roleId, permissionId) => 
      api.post(`rbac-service/roles/${roleId}/permissions`, { permission_id: permissionId }),
    assignBulk: (roleId, permissionIds, permissionValues) => 
      api.post(`rbac-service/roles/${roleId}/permissions`, permissionValues ? { permission_values: permissionValues } : { permission_ids: permissionIds }),
    getForRole: (roleId) => 
      api.get(`rbac-service/roles/${roleId}/permissions`),
    remove: (roleId, permissionId) => 
      api.delete(`rbac-service/roles/${roleId}/permissions/${permissionId}`)
  },
  
  // Authorization Check
  checkPermission: (roleId, permission) => 
    api.post('rbac-service/rbac/check-permission', { role_id: roleId, permission }),
  
  // Users
  users: {
    list: (page = 1, page_size = 10, search = '', status = 'active', roleId = '') => 
      api.get(`admin-service/users/list/super-admin?page=${page}&page_size=${page_size}&search=${search}&status=${status}${roleId ? `&role_id=${roleId}` : ''}`),
    assignRole: (userId, roleId) => 
      api.post('admin-service/users/role', { user_id: userId, role_id: roleId }),
    create: (data) =>
      api.post('admin-service/users', data),
    update: (userId, data) =>
      api.put(`admin-service/users/${userId}`, data)
  }
};